import { render, staticRenderFns } from "./AuthorPreview.vue?vue&type=template&id=28de8e72&scoped=true"
import script from "./AuthorPreview.vue?vue&type=script&lang=js"
export * from "./AuthorPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28de8e72",
  null
  
)

export default component.exports